import React, { useState } from "react"
import { MdContacts, MdOutlineFileDownload, MdOutlineTableView } from "react-icons/md"
import Button from "../../Form/Button"
import FormGroupInline from "../../Form/FormGroupInline"
import UploadArea from "../../UploadArea"
import styles from "./modalOutboundCampaign.module.css"

const ConfigAudienceSource = ({ source = {}, loading = false, reconciliation, onFileSelect = () => {}, handleChangeStep = () => {} }) => {
    const [isDraggingOver, setIsDraggingOver] = useState(false)
    const hasFile = Boolean(source?.file && source?.rows?.length)

    return (
        <>
            <div className={styles.stepIntro}>
                <strong>Escolha a origem dos contatos</strong>
                <span>A origem fica separada das demais configurações. Você poderá substituir a planilha sem perder nome, agendamento, responsáveis ou mensagem.</span>
            </div>
            <div className={styles.audienceSourceGrid}>
                <div className={`${styles.audienceSourceCard} ${styles.active}`}>
                    <MdOutlineTableView />
                    <div><strong>Importar planilha</strong><span>Arquivos XLS, XLSX ou CSV com até 10.000 registros.</span></div>
                    <small>Disponível</small>
                </div>
                <div className={`${styles.audienceSourceCard} ${styles.disabled}`} aria-disabled="true">
                    <MdContacts />
                    <div><strong>Contatos do sistema</strong><span>Selecione contatos usando filtros, funis e etiquetas da Oktto.</span></div>
                    <small>Em breve</small>
                </div>
            </div>
            <div
                className={styles.audienceUpload}
                onDragEnter={() => setIsDraggingOver(true)}
                onDragLeave={() => setIsDraggingOver(false)}
                onDrop={() => setIsDraggingOver(false)}
            >
                <UploadArea value={source?.file} isDraggingOver={isDraggingOver} onFileDrop={onFileSelect} />
                {loading && <div className={styles.fileLoading}>Lendo e validando arquivo…</div>}
            </div>
            {hasFile && (
                <div className={styles.fileSummary}>
                    <div><span>Arquivo</span><strong>{source.file.name}</strong></div>
                    <div><span>Registros</span><strong>{source.rows.length}</strong></div>
                    <div><span>Colunas</span><strong>{source.headers.length}</strong></div>
                    <div><span>Tamanho</span><strong>{(source.file.size / 1024).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} KB</strong></div>
                </div>
            )}
            {reconciliation && (
                <div className={`${styles.reconciliationNotice} ${reconciliation.invalidated ? styles.warning : ""}`}>
                    <strong>{reconciliation.invalidated ? "Planilha substituída com ajustes pendentes" : "Planilha substituída com sucesso"}</strong>
                    <span>{reconciliation.preserved} mapeamento{reconciliation.preserved === 1 ? " preservado" : "s preservados"}{reconciliation.invalidated ? ` e ${reconciliation.invalidated} precisa${reconciliation.invalidated === 1 ? "" : "m"} ser revisado${reconciliation.invalidated === 1 ? "" : "s"}` : ""}. {reconciliation.added} {reconciliation.added === 1 ? "nova coluna ficou disponível" : "novas colunas ficaram disponíveis"}.</span>
                </div>
            )}
            <div className={styles.modelDownload}>
                <div><strong>Precisa de um modelo?</strong><span>Baixe uma planilha com a estrutura recomendada para importação.</span></div>
                <a href="https://oktto-model.s3.us-east-1.amazonaws.com/files/Modelo_Oktto_Campanha.xlsx" download>
                    <Button type="button" variant="secondary" fullWidth={false}><MdOutlineFileDownload /> Baixar modelo</Button>
                </a>
            </div>
            <FormGroupInline>
                <Button variant="secondary" onClick={() => handleChangeStep(1)}>Voltar</Button>
                <Button variant="primary" onClick={() => handleChangeStep(3)} disabled={!hasFile || loading}>Revisar contatos</Button>
            </FormGroupInline>
        </>
    )
}

export default ConfigAudienceSource
